<div class="shell">

  <!-- ── Page content (fills full height — sidebar lives inside each routed page) ── -->
  <main class="shell__body">
    <router-outlet />
  </main>

  <!-- ── Agent Catalog ── browse agents on the left, their ready-made actions
       on the right; searching switches the right pane to matches across every
       agent so nothing is buried one agent deep. -->
  @if (catalogOpen()) {
    <div class="cat-overlay" (click)="closeCatalog()">
      <div class="cat-modal" role="dialog" aria-modal="true" aria-labelledby="cat-title"
           tabindex="-1" (click)="stop($event)">

        <header class="cat-head">
          <span class="cat-head__icon"><i class="pi pi-th-large"></i></span>
          <div class="cat-head__titles">
            <h2 class="cat-head__title" id="cat-title">Agent Catalog</h2>
            <p class="cat-head__sub">
              {{ catalogGroups().length }} agents · {{ totalActions() }} ready-made actions
            </p>
          </div>
          <label class="cat-search">
            <i class="pi pi-search cat-search__icon"></i>
            <input
              class="cat-search__input"
              type="text"
              placeholder="Search agents or actions…"
              aria-label="Search agents or actions"
              [value]="catalogSearch()"
              (input)="onCatalogSearchInput($event)"
            />
            @if (catalogSearch()) {
              <button type="button" class="cat-search__clear" (click)="clearCatalogSearch()"
                      aria-label="Clear search"><i class="pi pi-times"></i></button>
            }
          </label>
          <button class="cat-close" type="button" (click)="closeCatalog()" aria-label="Close catalog">
            <i class="pi pi-times"></i>
          </button>
        </header>

        <div class="cat-body">

          <nav class="cat-side" aria-label="Agents">
            @for (g of filteredCatalogGroups(); track g.agentId) {
              <button type="button" class="cat-side__item"
                      [class.cat-side__item--on]="!catalogQuery() && activeGroup()?.agentId === g.agentId"
                      (click)="selectCatalogAgent(g.agentId)">
                <span class="cat-side__letter">{{ g.letter }}</span>
                <span class="cat-side__name">{{ g.agentName }}</span>
                <span class="cat-side__n">{{ g.chats.length }}</span>
              </button>
            } @empty {
              <p class="cat-side__empty">No agents match.</p>
            }
          </nav>

          <section class="cat-main">
            @if (catalogQuery()) {
              <!-- Search view: flat hits across every agent. -->
              <div class="cat-main__head">
                <h3 class="cat-main__title">
                  {{ catalogResults().length }}
                  {{ catalogResults().length === 1 ? 'result' : 'results' }}
                  for "{{ catalogSearch() }}"
                </h3>
                <p class="cat-main__desc">Pick one to load it into chat, or choose an agent on the left to browse.</p>
              </div>
              @if (catalogResults().length === 0) {
                <p class="cat-main__empty">
                  Nothing matched. Try a shorter phrase, or browse the agents on the left.
                </p>
              } @else {
                <div class="cat-grid">
                  @for (hit of catalogResults(); track hit.agentId + '::' + hit.label) {
                    <button class="cat-card" type="button"
                            (click)="onQuickChatClick(hit.command, hit.prompt)">
                      <span class="cat-card__agent">{{ hit.agentName }}</span>
                      <span class="cat-card__label">{{ hit.label }}</span>
                      <i class="pi pi-arrow-right cat-card__arrow"></i>
                    </button>
                  }
                </div>
              }
            } @else if (activeGroup(); as g) {
              <!-- Browse view: one agent and everything it can do. -->
              <div class="cat-main__head">
                <div class="cat-main__title-row">
                  <h3 class="cat-main__title">{{ g.agentName }}</h3>
                  <button class="cat-cmd" type="button"
                          title="Insert this command — then type your own message"
                          (click)="onCommandClick(g.command)">{{ g.command }}</button>
                </div>
                @if (g.description) {
                  <p class="cat-main__desc">{{ g.description }}</p>
                }
              </div>

              <div class="cat-grid">
                <button class="cat-card cat-card--command" type="button"
                        (click)="onCommandClick(g.command)">
                  <span class="cat-card__agent">Free-form</span>
                  <span class="cat-card__label">Use <code>{{ g.command }}</code> and write my own message</span>
                  <i class="pi pi-pencil cat-card__arrow"></i>
                </button>
                @for (chat of g.chats; track chat.label) {
                  <button class="cat-card" type="button"
                          (click)="onQuickChatClick(g.command, chat.prompt)">
                    <span class="cat-card__label">{{ chat.label }}</span>
                    <i class="pi pi-arrow-right cat-card__arrow"></i>
                  </button>
                }
              </div>
            } @else {
              <p class="cat-main__empty">No agents available.</p>
            }
          </section>

        </div>

        <footer class="cat-foot">
          Pick an action to load it into chat — or pick a command to write your own message.
        </footer>

      </div>
    </div>
  }

  <!-- ── Read-only Abilities modal (opened from any surface's rail) ── -->
  <app-abilities-modal />

  <!-- ── Per-user OAuth connectors, opened from any surface's rail (and by the
       /connections OAuth return route) ── -->
  <app-connections-modal />

  <!-- ── What's New announcements + guided tour (global overlays, driven by
       their services so any routed page can open/auto-open them) ── -->
  <app-whats-new-modal />
  <app-guided-tour />

</div>
